export default "__VITE_ASSET__2d47946f__"